__turbopack_context__.v({
  "container": "_6vTGSa_container",
  "label": "_6vTGSa_label",
  "name": "_6vTGSa_name",
  "table": "_6vTGSa_table",
});
